import React from 'react'
import { z } from 'zod'

const TelegramUserSchema = z.object({
  id: z.number(),
  is_bot: z.boolean().optional(),
  first_name: z.string(),
  last_name: z.string().optional(),
  username: z.string().optional(),
  language_code: z.string().optional(),
  is_premium: z.boolean().optional(),
  photo_url: z.string().optional(),
})
export type TelegramUser = z.infer<typeof TelegramUserSchema>

export const useTelegramUser = (params: URLSearchParams) => {
  return React.useMemo(() => {
    const json = params.get('user')
    if (!json) return null

    const user = JSON.parse(json)
    return TelegramUserSchema.parse(user)
  }, [params])
}
